Immutable.List.prototype.upsert = function<T>(this: Immutable.List<T>, predicateFind: (value?: T) => boolean, value: T): Immutable.List<T> {
    let index = this.findIndex(predicateFind);
    if (index != -1)
        return this.update(index, item => {
            item = value;
            return item;
        });
    else
        return this.push(value);
};

Immutable.List.prototype.filterImmutable = function<T>(this: Immutable.List<T>, predicate: (value?: T) => boolean): Immutable.List<T> {
    return this.toArray().filter(predicate).toImmutable();
};

Immutable.List.prototype.mutate = function<T>(this: Immutable.List<T>, mutation: (value?: T) => void, where: (item: T) => boolean): Immutable.List<T> {
    return this.toArray().mutate(mutation, where).toImmutable();
};

$.fn.moveCursorToEnd = function(this): void {
    if (this == null)
        return;

    if (!!this && this.length > 0 && !!this[0].value)
        this.setCursorPosition(this[0].value.length);
};

$.fn.setCursorPosition = function(this, pos: number): void {
    if (this == null)
        return;

    this.each((index, elem) => {
        if (elem.setSelectionRange) {
            elem.setSelectionRange(pos, pos);
        }
        else if (elem.createTextRange) {
            const range = elem.createTextRange();
            range.collapse(true);
            range.moveEnd("character", pos);
            range.moveStart("character", pos);
            range.select();
        }
    });
};
